// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/feed_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Conversation, FeedEntry, FeedEntryType } from "./feed_pb.ts";
import { Family } from "./advisors_service_pb.ts";
import { AccountStub } from "./common_pb.ts";

/**
 * @generated from message protogen.GroupThread
 */
export class GroupThread extends Message<GroupThread> {
  /**
   * @generated from field: repeated string memberRefs = 1;
   */
  memberRefs: string[] = [];

  constructor(data?: PartialMessage<GroupThread>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GroupThread";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "memberRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GroupThread {
    return new GroupThread().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GroupThread {
    return new GroupThread().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GroupThread {
    return new GroupThread().fromJsonString(jsonString, options);
  }

  static equals(a: GroupThread | PlainMessage<GroupThread> | undefined, b: GroupThread | PlainMessage<GroupThread> | undefined): boolean {
    return proto3.util.equals(GroupThread, a, b);
  }
}

/**
 * @generated from message protogen.GetAdvisorActivityFeedRequest
 */
export class GetAdvisorActivityFeedRequest extends Message<GetAdvisorActivityFeedRequest> {
  /**
   * @generated from field: string familyRef = 1;
   */
  familyRef = "";

  /**
   * Need to enrich this.
   *
   * @generated from field: string startCursor = 2;
   */
  startCursor = "";

  /**
   * @generated from field: bool markConversationsRead = 3;
   */
  markConversationsRead = false;

  /**
   * @generated from field: int32 pageSize = 4;
   */
  pageSize = 0;

  /**
   * @generated from field: string direction = 5;
   */
  direction = "";

  /**
   * @generated from field: repeated protogen.FeedEntryType entryTypes = 6;
   */
  entryTypes: FeedEntryType[] = [];

  /**
   * @generated from field: bool includeGroupThreads = 7;
   */
  includeGroupThreads = false;

  constructor(data?: PartialMessage<GetAdvisorActivityFeedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAdvisorActivityFeedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "familyRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "startCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "markConversationsRead", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "pageSize", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "direction", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "entryTypes", kind: "enum", T: proto3.getEnumType(FeedEntryType), repeated: true },
    { no: 7, name: "includeGroupThreads", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAdvisorActivityFeedRequest {
    return new GetAdvisorActivityFeedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAdvisorActivityFeedRequest {
    return new GetAdvisorActivityFeedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAdvisorActivityFeedRequest {
    return new GetAdvisorActivityFeedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAdvisorActivityFeedRequest | PlainMessage<GetAdvisorActivityFeedRequest> | undefined, b: GetAdvisorActivityFeedRequest | PlainMessage<GetAdvisorActivityFeedRequest> | undefined): boolean {
    return proto3.util.equals(GetAdvisorActivityFeedRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetAdvisorActivityFeedResponse
 */
export class GetAdvisorActivityFeedResponse extends Message<GetAdvisorActivityFeedResponse> {
  /**
   * @generated from field: protogen.Family family = 1;
   */
  family?: Family;

  /**
   * @generated from field: repeated protogen.Conversation conversations = 2;
   */
  conversations: Conversation[] = [];

  /**
   * @generated from field: repeated protogen.FeedEntry entries = 3;
   */
  entries: FeedEntry[] = [];

  /**
   * @generated from field: repeated protogen.AccountStub accounts = 4;
   */
  accounts: AccountStub[] = [];

  /**
   * @generated from field: string startCursor = 5;
   */
  startCursor = "";

  /**
   * @generated from field: string nextCursor = 6;
   */
  nextCursor = "";

  /**
   * @generated from field: bool hasMore = 7;
   */
  hasMore = false;

  /**
   * @generated from field: bool readStatusUpdated = 8;
   */
  readStatusUpdated = false;

  /**
   * @generated from field: repeated protogen.GroupThread groupThreads = 9;
   */
  groupThreads: GroupThread[] = [];

  constructor(data?: PartialMessage<GetAdvisorActivityFeedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAdvisorActivityFeedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "family", kind: "message", T: Family },
    { no: 2, name: "conversations", kind: "message", T: Conversation, repeated: true },
    { no: 3, name: "entries", kind: "message", T: FeedEntry, repeated: true },
    { no: 4, name: "accounts", kind: "message", T: AccountStub, repeated: true },
    { no: 5, name: "startCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "nextCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "hasMore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "readStatusUpdated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "groupThreads", kind: "message", T: GroupThread, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAdvisorActivityFeedResponse {
    return new GetAdvisorActivityFeedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAdvisorActivityFeedResponse {
    return new GetAdvisorActivityFeedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAdvisorActivityFeedResponse {
    return new GetAdvisorActivityFeedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAdvisorActivityFeedResponse | PlainMessage<GetAdvisorActivityFeedResponse> | undefined, b: GetAdvisorActivityFeedResponse | PlainMessage<GetAdvisorActivityFeedResponse> | undefined): boolean {
    return proto3.util.equals(GetAdvisorActivityFeedResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetMemberActivityFeedRequest
 */
export class GetMemberActivityFeedRequest extends Message<GetMemberActivityFeedRequest> {
  /**
   * @generated from field: string startCursor = 1;
   */
  startCursor = "";

  /**
   * @generated from field: bool markConversationsRead = 2;
   */
  markConversationsRead = false;

  /**
   * @generated from field: int32 pageSize = 3;
   */
  pageSize = 0;

  /**
   * @generated from field: string direction = 4;
   */
  direction = "";

  /**
   * @generated from field: repeated protogen.FeedEntryType entryTypes = 5;
   */
  entryTypes: FeedEntryType[] = [];

  constructor(data?: PartialMessage<GetMemberActivityFeedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetMemberActivityFeedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "startCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "markConversationsRead", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "pageSize", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "direction", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "entryTypes", kind: "enum", T: proto3.getEnumType(FeedEntryType), repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMemberActivityFeedRequest {
    return new GetMemberActivityFeedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMemberActivityFeedRequest {
    return new GetMemberActivityFeedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMemberActivityFeedRequest {
    return new GetMemberActivityFeedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMemberActivityFeedRequest | PlainMessage<GetMemberActivityFeedRequest> | undefined, b: GetMemberActivityFeedRequest | PlainMessage<GetMemberActivityFeedRequest> | undefined): boolean {
    return proto3.util.equals(GetMemberActivityFeedRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetMemberActivityFeedResponse
 */
export class GetMemberActivityFeedResponse extends Message<GetMemberActivityFeedResponse> {
  /**
   * @generated from field: protogen.Family family = 1;
   */
  family?: Family;

  /**
   * @generated from field: repeated protogen.Conversation conversations = 2;
   */
  conversations: Conversation[] = [];

  /**
   * @generated from field: repeated protogen.FeedEntry entries = 3;
   */
  entries: FeedEntry[] = [];

  /**
   * @generated from field: repeated protogen.AccountStub accounts = 4;
   */
  accounts: AccountStub[] = [];

  /**
   * @generated from field: string startCursor = 5;
   */
  startCursor = "";

  /**
   * @generated from field: string nextCursor = 6;
   */
  nextCursor = "";

  /**
   * @generated from field: bool hasMore = 7;
   */
  hasMore = false;

  /**
   * @generated from field: bool readStatusUpdated = 8;
   */
  readStatusUpdated = false;

  constructor(data?: PartialMessage<GetMemberActivityFeedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetMemberActivityFeedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "family", kind: "message", T: Family },
    { no: 2, name: "conversations", kind: "message", T: Conversation, repeated: true },
    { no: 3, name: "entries", kind: "message", T: FeedEntry, repeated: true },
    { no: 4, name: "accounts", kind: "message", T: AccountStub, repeated: true },
    { no: 5, name: "startCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "nextCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "hasMore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "readStatusUpdated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMemberActivityFeedResponse {
    return new GetMemberActivityFeedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMemberActivityFeedResponse {
    return new GetMemberActivityFeedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMemberActivityFeedResponse {
    return new GetMemberActivityFeedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMemberActivityFeedResponse | PlainMessage<GetMemberActivityFeedResponse> | undefined, b: GetMemberActivityFeedResponse | PlainMessage<GetMemberActivityFeedResponse> | undefined): boolean {
    return proto3.util.equals(GetMemberActivityFeedResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetAdvisorPublicActivityFeedRequest
 */
export class GetAdvisorPublicActivityFeedRequest extends Message<GetAdvisorPublicActivityFeedRequest> {
  /**
   * @generated from field: string advisorRef = 1;
   */
  advisorRef = "";

  /**
   * @generated from field: string startCursor = 2;
   */
  startCursor = "";

  /**
   * @generated from field: int32 pageSize = 3;
   */
  pageSize = 0;

  /**
   * @generated from field: string direction = 4;
   */
  direction = "";

  constructor(data?: PartialMessage<GetAdvisorPublicActivityFeedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAdvisorPublicActivityFeedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "advisorRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "startCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "pageSize", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "direction", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAdvisorPublicActivityFeedRequest {
    return new GetAdvisorPublicActivityFeedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAdvisorPublicActivityFeedRequest {
    return new GetAdvisorPublicActivityFeedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAdvisorPublicActivityFeedRequest {
    return new GetAdvisorPublicActivityFeedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAdvisorPublicActivityFeedRequest | PlainMessage<GetAdvisorPublicActivityFeedRequest> | undefined, b: GetAdvisorPublicActivityFeedRequest | PlainMessage<GetAdvisorPublicActivityFeedRequest> | undefined): boolean {
    return proto3.util.equals(GetAdvisorPublicActivityFeedRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetAdvisorPublicActivityFeedResponse
 */
export class GetAdvisorPublicActivityFeedResponse extends Message<GetAdvisorPublicActivityFeedResponse> {
  /**
   * @generated from field: repeated protogen.FeedEntry entries = 1;
   */
  entries: FeedEntry[] = [];

  /**
   * @generated from field: repeated protogen.AccountStub accounts = 2;
   */
  accounts: AccountStub[] = [];

  /**
   * @generated from field: string startCursor = 3;
   */
  startCursor = "";

  /**
   * @generated from field: string nextCursor = 4;
   */
  nextCursor = "";

  /**
   * @generated from field: bool hasMore = 5;
   */
  hasMore = false;

  constructor(data?: PartialMessage<GetAdvisorPublicActivityFeedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAdvisorPublicActivityFeedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entries", kind: "message", T: FeedEntry, repeated: true },
    { no: 2, name: "accounts", kind: "message", T: AccountStub, repeated: true },
    { no: 3, name: "startCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "nextCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "hasMore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAdvisorPublicActivityFeedResponse {
    return new GetAdvisorPublicActivityFeedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAdvisorPublicActivityFeedResponse {
    return new GetAdvisorPublicActivityFeedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAdvisorPublicActivityFeedResponse {
    return new GetAdvisorPublicActivityFeedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAdvisorPublicActivityFeedResponse | PlainMessage<GetAdvisorPublicActivityFeedResponse> | undefined, b: GetAdvisorPublicActivityFeedResponse | PlainMessage<GetAdvisorPublicActivityFeedResponse> | undefined): boolean {
    return proto3.util.equals(GetAdvisorPublicActivityFeedResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetBotConversationFeedRequest
 */
export class GetBotConversationFeedRequest extends Message<GetBotConversationFeedRequest> {
  /**
   * @generated from field: string conversationRef = 1;
   */
  conversationRef = "";

  /**
   * @generated from field: string startCursor = 2;
   */
  startCursor = "";

  /**
   * @generated from field: int32 pageSize = 3;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<GetBotConversationFeedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetBotConversationFeedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "conversationRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "startCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "pageSize", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBotConversationFeedRequest {
    return new GetBotConversationFeedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBotConversationFeedRequest {
    return new GetBotConversationFeedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBotConversationFeedRequest {
    return new GetBotConversationFeedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBotConversationFeedRequest | PlainMessage<GetBotConversationFeedRequest> | undefined, b: GetBotConversationFeedRequest | PlainMessage<GetBotConversationFeedRequest> | undefined): boolean {
    return proto3.util.equals(GetBotConversationFeedRequest, a, b);
  }
}

/**
 * @generated from message protogen.AddedBotTask
 */
export class AddedBotTask extends Message<AddedBotTask> {
  /**
   * @generated from field: string taskRef = 1;
   */
  taskRef = "";

  /**
   * @generated from field: string messageRef = 2;
   */
  messageRef = "";

  /**
   * @generated from field: string title = 3;
   */
  title = "";

  /**
   * @generated from field: string priority = 4;
   */
  priority = "";

  /**
   * @generated from field: string stage = 5;
   */
  stage = "";

  /**
   * @generated from field: int64 createdSec = 6;
   */
  createdSec = protoInt64.zero;

  constructor(data?: PartialMessage<AddedBotTask>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AddedBotTask";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "taskRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "messageRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "priority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "stage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddedBotTask {
    return new AddedBotTask().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddedBotTask {
    return new AddedBotTask().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddedBotTask {
    return new AddedBotTask().fromJsonString(jsonString, options);
  }

  static equals(a: AddedBotTask | PlainMessage<AddedBotTask> | undefined, b: AddedBotTask | PlainMessage<AddedBotTask> | undefined): boolean {
    return proto3.util.equals(AddedBotTask, a, b);
  }
}

/**
 * @generated from message protogen.AddedBotEvent
 */
export class AddedBotEvent extends Message<AddedBotEvent> {
  /**
   * @generated from field: string eventRef = 1;
   */
  eventRef = "";

  /**
   * @generated from field: string messageRef = 2;
   */
  messageRef = "";

  /**
   * @generated from field: string title = 3;
   */
  title = "";

  /**
   * @generated from field: int64 startSec = 4;
   */
  startSec = protoInt64.zero;

  /**
   * @generated from field: bool allDay = 5;
   */
  allDay = false;

  /**
   * @generated from field: int64 createdSec = 6;
   */
  createdSec = protoInt64.zero;

  constructor(data?: PartialMessage<AddedBotEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AddedBotEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "messageRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "startSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "allDay", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AddedBotEvent {
    return new AddedBotEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AddedBotEvent {
    return new AddedBotEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AddedBotEvent {
    return new AddedBotEvent().fromJsonString(jsonString, options);
  }

  static equals(a: AddedBotEvent | PlainMessage<AddedBotEvent> | undefined, b: AddedBotEvent | PlainMessage<AddedBotEvent> | undefined): boolean {
    return proto3.util.equals(AddedBotEvent, a, b);
  }
}

/**
 * @generated from message protogen.GetBotConversationFeedResponse
 */
export class GetBotConversationFeedResponse extends Message<GetBotConversationFeedResponse> {
  /**
   * @generated from field: repeated protogen.FeedEntry entries = 1;
   */
  entries: FeedEntry[] = [];

  /**
   * @generated from field: repeated protogen.AccountStub accounts = 2;
   */
  accounts: AccountStub[] = [];

  /**
   * @generated from field: string nextCursor = 3;
   */
  nextCursor = "";

  /**
   * @generated from field: bool hasMore = 4;
   */
  hasMore = false;

  /**
   * @generated from field: map<string, string> messageAgentThreadRefs = 5;
   */
  messageAgentThreadRefs: { [key: string]: string } = {};

  /**
   * @generated from field: repeated protogen.AddedBotTask addedTasks = 6;
   */
  addedTasks: AddedBotTask[] = [];

  /**
   * @generated from field: repeated protogen.AddedBotEvent addedEvents = 7;
   */
  addedEvents: AddedBotEvent[] = [];

  constructor(data?: PartialMessage<GetBotConversationFeedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetBotConversationFeedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entries", kind: "message", T: FeedEntry, repeated: true },
    { no: 2, name: "accounts", kind: "message", T: AccountStub, repeated: true },
    { no: 3, name: "nextCursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "hasMore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "messageAgentThreadRefs", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 6, name: "addedTasks", kind: "message", T: AddedBotTask, repeated: true },
    { no: 7, name: "addedEvents", kind: "message", T: AddedBotEvent, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBotConversationFeedResponse {
    return new GetBotConversationFeedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBotConversationFeedResponse {
    return new GetBotConversationFeedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBotConversationFeedResponse {
    return new GetBotConversationFeedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBotConversationFeedResponse | PlainMessage<GetBotConversationFeedResponse> | undefined, b: GetBotConversationFeedResponse | PlainMessage<GetBotConversationFeedResponse> | undefined): boolean {
    return proto3.util.equals(GetBotConversationFeedResponse, a, b);
  }
}

